import React from 'react';
import PropTypes from 'prop-types';

import RaisedButton from 'material-ui/RaisedButton';

import './ActionBlock.css';

const ActionBlock = ({history, isActive, title, subtitle, link, className}) => {
  let style = { marginTop: 6 };
  return (
    <div className={`ActionBlock ${className}`}>
      <h4>{title}</h4>
      {subtitle}<br />
      <RaisedButton backgroundColor="#f0f0f0" label={`${isActive ? 'Open' : 'Explore'}`}
        style={style}
        onTouchTap={() => history.push(`${!isActive ? '/explore' : ''}/${link}`)} />
    </div>
  );
}

ActionBlock.propTypes = {
  history: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
}

/* eslint-disable react/prop-types */

const ActionBlockAmp = ({history, active}) => (
  <ActionBlock
    title="Amplification service"
    subtitle="Amplify your audience."
    link="amp"
    className="AudAmp"
    isActive={active}
    history={history}
  />
);

const ActionBlockDashboard = ({ history, active }) => (
  <ActionBlock
    title="Reporting"
    subtitle="Get insights into your data."
    link="dash"
    className="Dashboard"
    isActive={active}
    history={history}
  />
);

const ActionBlockStoreVisitation = ({ history, active }) => (
  <ActionBlock
    title="Cross Channel Store Visitation Rate"
    subtitle="Explore the effect each digital media channel has on consumers’ offline behavior."
    link="store_visitation"
    className="StoreVisitation"
    isActive={active}
    history={history}
  />
);

const ActionBlockPoi = ({ history, active }) => (
  <ActionBlock
    title="POI Audience"
    subtitle="Get the full picture with analytics on your users offline behaviors and activate across all channels."
    link="poi"
    className="POI"
    isActive={active}
    history={history}
  />
);

const ActionBlockCrm = ({ history, active }) => (
  <ActionBlock
    title="CRM Onboarding at Scale"
    subtitle="Screen6 syncs between PII providers IDs already included in your private graph ensuring the highest match rate."
    link="crm_onboarding"
    className="CrmOnboarding"
    isActive={active}
    history={history}
  />
);

const ActionBlockGrapeshot = ({ history, active }) => (
  <ActionBlock
    title="Grapeshot Audience Segmentation"
    subtitle="Leverage Grapeshot’s keyword technology to segment your audience based on their cross-device behavior."
    link="partner_grapeshot"
    className="Grapeshot"
    isActive={active}
    history={history}
  />
);

const ActionBlockHouseholding = ({ history, active }) => (
  <ActionBlock
    title="Advanced Householding"
    subtitle={
      "Enable targeting at the household level while eliminating waste." +
        (active ? " (Integrated within the amplification service)" : "")
    }
    link={active ? 'amp' : 'householding'}
    className="Householding"
    isActive={active}
    history={history}
  />
);

const ActionBlockTrueReach = ({ history, active }) => (
  <ActionBlock
    title="Campaign Analytics &amp; Reporting"
    subtitle="Access campaign-level analytics and reporting representing TrueReach™ and frequency at the individual level."
    link="truereach"
    className="TrueReach"
    isActive={active}
    history={history}
  />
);

const ActionBlockGraphExpansion = ({ history, active }) => (
  <ActionBlock
    title="Graph Expansion"
    subtitle="Expand the reach of your graph beyond your own dataset through Screen6’s strategic partners."
    link="graph_expansion"
    className="GraphExpansion"
    isActive={active}
    history={history}
  />
);

export {
  ActionBlock as default,
  ActionBlockAmp,
  ActionBlockCrm,
  ActionBlockDashboard,
  ActionBlockGrapeshot,
  ActionBlockGraphExpansion,
  ActionBlockHouseholding,
  ActionBlockPoi,
  ActionBlockStoreVisitation,
  ActionBlockTrueReach,
}



// WEBPACK FOOTER //
// ./src/components/ActionBlock/index.jsx